module.exports = __webpack_public_path__ + "static/media/Lucian.f20ca11c.png";